import { render, staticRenderFns } from "./hzClause.vue?vue&type=template&id=1a7bf6b2&scoped=true"
import script from "./hzClause.vue?vue&type=script&lang=js"
export * from "./hzClause.vue?vue&type=script&lang=js"
import style0 from "./hzClause.vue?vue&type=style&index=0&id=1a7bf6b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7bf6b2",
  null
  
)

export default component.exports